import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { DirectivesModule } from '@core/directives/directives.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { CreateOrEditPendencyDialogComponent } from './components/create-or-edit-pendency-dialog/create-or-edit-pendency-dialog.component';
import { UpdateAssigneeModalComponent } from './components/update-assignee-modal/update-assignee-modal.component';
import { PendenciesComponent } from './pendencies.component';
import { PendenciesService } from './service/pendencies.service';

@NgModule({
  entryComponents: [CreateOrEditPendencyDialogComponent, UpdateAssigneeModalComponent],
  declarations: [PendenciesComponent, CreateOrEditPendencyDialogComponent, UpdateAssigneeModalComponent],
  imports: [
    CommonModule,
    DirectivesModule,
    FuseSharedModule,
    TranslateModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    FuseSharedModule,
    MatProgressSpinnerModule,
    DisclaimerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    PendenciesComponent
  ],
  providers: [
    PendenciesService
  ]
})
export class PendenciesModule { }
